// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3G374","selected":"Chip_selected__27QMW"};